document.addEventListener('DOMContentLoaded', () => {
  const content = document.querySelector('.lesson-detail-content.prose');
  const toc = document.getElementById('article-toc');
  if (!content || !toc) return;

  const headings = content.querySelectorAll('h2, h3');
  const list = toc.querySelector('.article-toc-nav ul');
  if (!headings.length || !list) return;

  const slugify = (text) => {
    return (text || '')
      .toLowerCase()
      .trim()
      .replace(/["'`]/g, '')
      .replace(/[^\w\s-]+/g, '')
      .replace(/\s+/g, '-')
      .substring(0, 80);
  };

  let currentH2Li = null;
  let hasAny = false;

  headings.forEach((el, idx) => {
    const tag = el.tagName.toLowerCase();
    const originalText = (el.textContent || '').trim();

    if (!el.id) {
      const base = slugify(el.textContent || `section-${idx + 1}`);
      let id = base;
      let counter = 1;
      while (document.getElementById(id)) {
        id = `${base}-${counter++}`;
      }
      el.id = id;
    }

    const anchorBtn = document.createElement('a');
    anchorBtn.href = `#${el.id}`;
    anchorBtn.className = 'heading-anchor';
    anchorBtn.setAttribute('aria-label', 'Copy link');
    anchorBtn.textContent = '#';
    el.classList.add('has-heading-anchor');
    el.insertBefore(anchorBtn, el.firstChild);

    anchorBtn.addEventListener('click', (ev) => {
      ev.preventDefault();
      const url = `${location.origin}${location.pathname}#${el.id}`;
      const showCopied = () => {
        const toast = document.createElement('span');
        toast.className = 'heading-anchor-toast';
        toast.textContent = 'Copied';
        anchorBtn.appendChild(toast);
        setTimeout(() => toast.remove(), 1200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          history.replaceState(null, '', `#${el.id}`);
          showCopied();
        }).catch(() => {
          showCopied();
        });
      } else {
        const ta = document.createElement('textarea');
        ta.value = url;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch(e) {}
        document.body.removeChild(ta);
        history.replaceState(null, '', `#${el.id}`);
        showCopied();
      }
    });

    const a = document.createElement('a');
    a.href = `#${el.id}`;
    a.textContent = originalText.replace(/^#\s*/, '');
    a.className = 'article-toc-link';

    if (tag === 'h2') {
      const li = document.createElement('li');
      li.className = 'toc-h2';
      li.appendChild(a);
      list.appendChild(li);
      currentH2Li = li;
      hasAny = true;
    } else if (tag === 'h3') {
      const li = document.createElement('li');
      li.className = 'toc-h3';
      li.appendChild(a);

      if (!currentH2Li) {
        const wrap = document.createElement('li');
        wrap.className = 'toc-h2';
        const ul = document.createElement('ul');
        ul.appendChild(li);
        wrap.appendChild(ul);
        list.appendChild(wrap);
      } else {
        let sub = currentH2Li.querySelector('ul');
        if (!sub) {
          sub = document.createElement('ul');
          currentH2Li.appendChild(sub);
        }
        sub.appendChild(li);
      }
      hasAny = true;
    }
  });

  if (hasAny) {
    toc.hidden = false;
  }

  const style = document.createElement('style');
  style.textContent = `
  .article-toc{padding:14px 0;margin:16px 0;border-bottom:1px solid var(--color-border, #e5e5e5);border-top:1px solid var(--color-border, #e5e5e5)}
  .article-toc-title{font-weight:600;margin:0 0 8px;font-size:20px;color:#2c2d2e}
  .article-toc-nav ul{list-style:disc;margin:0;padding-left:1.25rem}
  .article-toc-nav li{margin:4px 0}
  .article-toc-nav .toc-h3{margin-left:16px}
  .article-toc-link{text-decoration:none;color:var(--color-accent,#3f72e5)}
  .article-toc-link:hover{text-decoration:underline}
  .lesson-detail-content.prose h2.has-heading-anchor, .lesson-detail-content.prose h3.has-heading-anchor{position:relative}
  .lesson-detail-content.prose .heading-anchor{position:absolute;left:-26px;top:50%;transform:translateY(-50%);opacity:0;transition:opacity .15s ease;display:inline-flex;align-items:center;justify-content:center;width:25px;height:18px;color:var(--color-text-light,#7a7a7a);z-index:10;cursor:pointer;font-size:18px;text-decoration:none;font-weight:400}
  .lesson-detail-content.prose h2.has-heading-anchor .heading-anchor{top:0;transform:translateY(12px)}
  .lesson-detail-content.prose h2:hover .heading-anchor, .lesson-detail-content.prose h3:hover .heading-anchor{opacity:1}
  .lesson-detail-content.prose .heading-anchor:hover{opacity:1}
  .lesson-detail-content.prose .heading-anchor svg{width:18px;height:18px;display:block}
  .lesson-detail-content.prose .heading-anchor-toast{position:absolute;left:50%;transform:translateX(-50%);bottom:100%;margin-bottom:4px;background:#111;color:#fff;font-size:11px;line-height:1;padding:6px 8px;border-radius:6px;box-shadow:0 2px 10px rgba(0,0,0,.15);white-space:nowrap;pointer-events:none}
  `;
  document.head.appendChild(style);
}); 